import React from 'react';
import { get } from 'lodash';
import VideoPlayer from './videojs-player';
import { checkValue } from '../../../utils/functions';
import ModuleColorBar from 'src/components/common/modules/module-color-bar/module-color-bar';

const VideoDetails = (props: any) => {
  const getVideos = () => {
    const content = props;
    let isBackgroundImage = false;
    let isYoutube = false;

    if (checkValue(content.videoFile) || checkValue(content.youtubeId) || checkValue(content.videoFilePath)) {
      let videoJsOptions = {};
      if (checkValue(content.videoFile) || checkValue(content.videoFilePath)) {
        videoJsOptions = {
          autoplay: get(content, 'autoplay', true),
          controls: true,
          copyrightText: content.copyrightText,
          siteid: props.siteid,
          campaignUrl: props.campaignUrl,
          template: props.template,
          sources: [
            {
              src: content.videoFilePath || content.videoFile[0].url,
              type: 'video/mp4',
            },
          ],
        };
      } else if (checkValue(content.youtubeId)) {
        // Check YoutubeId has vimeo
        // This requirement check the youtubeId param it can be have
        // Youtube or vimeo base on the value we switch the video
        const reg = /^\d+$/; // number only
        const url =
          !content.youtubeId.includes('vimeo') && !content.youtubeId.includes('www.youtube')
            ? content.youtubeId.match(reg)
              ? `https://vimeo.com/${content.youtubeId}`
              : `https://www.youtube.com/embed/${content.youtubeId}`
            : content.youtubeId;

        try {
          const videoURL = new URL(url);
          if (videoURL.hostname.indexOf('vimeo') > -1) {
            videoJsOptions = {
              techOrder: ['vimeo'],
              autoplay: get(content, 'autoplay', true),
              muted: true,
              preload: 'auto',
              controls: true,
              sources: [
                {
                  src: content.youtubeId,
                  type: 'video/vimeo',
                },
              ],
            };
          } else {
            isYoutube = true;
            videoJsOptions = {
              techOrder: ['youtube'],
              autoplay: get(content, 'autoplay', true),
              controls: true,
              copyrightText: content.copyrightText,
              siteid: props.siteid,
              campaignUrl: props.campaignUrl,
              template: props.template,
              sources: [
                {
                  src: content.youtubeId,
                  type: 'video/youtube',
                },
              ],
            };
          }
        } catch (error) {
          console.log(error, 'Invalid video url');
        }
      }

      if (
        content.staticImage !== undefined &&
        content.staticImage !== null &&
        content.staticImage !== '' &&
        content.staticImage.length > 0
      ) {
        const filteredData = content.staticImage.filter((heroItem) => heroItem.name.includes(props.device));
        if (filteredData[0] && filteredData[0] !== undefined && filteredData[0] !== null && filteredData[0] !== '') {
          const imgURL: string = filteredData[0].url;
          videoJsOptions['poster'] = imgURL;
          if (isYoutube) {
            isBackgroundImage = true;
          }
        }
      }

      const videoProps = {
        videoOptions: videoJsOptions,
        isBackground: isBackgroundImage,
        exClassVideo: get(props, 'exClassVideo', ''),
        onPlayVideo: checkValue(props?.onPlayVideo) ? () => props?.onPlayVideo() : undefined
      };

      const isColorBarsAvailable =
        checkValue(props?.colorBarProps) &&
        Object.keys(props?.colorBarProps).some((el) => checkValue(props?.colorBarProps[el]));

      return (
        <div
          className={`video-wrapper ${isColorBarsAvailable ? 'has-module-color-bar' : ''} ${
            props?.loadedClass
          } video-player-icon-${props?.playIcon}`}
        >
          {isColorBarsAvailable ? <ModuleColorBar {...props?.colorBarProps} /> : null}
          <VideoPlayer {...videoProps} />
        </div>
      );
    }
  };

  return <>{getVideos()}</>;
};

export default VideoDetails;
